import { AuthFlow } from '@griply/types';
import { verifyPasswordResetCode } from 'firebase/auth';

import { getAuthentication, handleAuthError } from './helpers';

export const getEmailByOobcode = async (oobCode: string) => {
  try {
    const auth = await getAuthentication();

    return await verifyPasswordResetCode(auth, oobCode);
  } catch (e) {
    throw handleAuthError(e, AuthFlow.ResetLinkLookup);
  }
};
